import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { Button } from "../../components/Button";
import { DEPRECATED_Card } from "../../components/DEPRECATED_Card/DEPRECATED_Card";
import { Notification } from "../../components/Notification/Notification";
import styles from "./OneTrustErrorBanner.module.scss";
const { sanitize } = dompurify;
export const OneTrustErrorBanner = ({ redirectUrl, linkText, errorMessage, title }) => {
    const redirect = () => {
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    };
    return (_jsx("div", { className: styles.wrapper, children: _jsx(DEPRECATED_Card, { variant: "variant4", title: title, classNameContent: styles.cardContent, classNameTitle: styles.cardTitle, className: styles.card, children: _jsx(Notification, { variant: "error", showIcon: false, children: _jsxs("div", { className: styles.errorBlock, children: [_jsx("div", { className: styles.errorMessage, dangerouslySetInnerHTML: {
                                __html: sanitize(errorMessage),
                            } }), redirectUrl && linkText && (_jsx(Button, { color: "primary", onClick: redirect, children: linkText }))] }) }) }) }));
};
//# sourceMappingURL=OneTrustErrorBanner.js.map